import {put, takeEvery} from "redux-saga/effects";
import {Sku} from "../../../Models/Sku";
import {fillItems} from "../../utils";
import {
    skuCreateError,
    skuCreateSuccess,
    skuLoadError,
    skuLoadSuccess,
    skusGetError,
    skusGetSuccess,
    skuUpdateError,
    skuUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* skusSagas() {
    yield takeEvery(TYPES.SKUS_GET_REQUEST, skusGetRequest);
    yield takeEvery(TYPES.SKU_LOAD_REQUEST, skuLoadRequest);
    yield takeEvery(TYPES.SKU_CREATE_REQUEST, skuCreateRequest);
    yield takeEvery(TYPES.SKU_UPDATE_REQUEST, skuUpdateRequest);
}

function* skusGetRequest(action) {
    try {
        const response = yield Sku.index({
            ...action.payload,
        });

        yield put(
            skusGetSuccess({
                ...fillItems(response, Sku),
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(skusGetError(error));
    }
}

function* skuLoadRequest(action) {
    try {
        const response = yield Sku.find(action.payload);

        yield put(
            skuLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(skuLoadError(error));
    }
}

function* skuCreateRequest(action) {
    try {
        const response = yield Sku.create(action.payload);

        yield put(
            skuCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(skuCreateError(error));
    }
}

function* skuUpdateRequest(action) {
    try {
        const response = yield Sku.update(action.payload.id, action.payload);

        yield put(
            skuUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(skuUpdateError(error));
    }
}
